module.exports = __webpack_public_path__ + "16cd8cc365184b48cbb90ed0f7db864f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connectedapp.jpg
// module id = 169
// module chunks = 0